import { NavLink } from "react-router-dom"

const Glosario = () => {
    return (<>
        <main className="py-5 mb-5" style={{ 'background-color': '#2222221A' }}>
            <section className="container" style={{ 'max-width': '1200px' }}>
                <div className="row" style={{ 'marginRight': '0px' }}>
                    <div className="col-12">
                        <div className="py-3 px-4" style={{
                            'padding': '30px',
                            'borderRadius': '15px'
                        }}>
                            <div className="row">
                                <div className="col-12 col-md-7 pl-5 py-4">
                                    <h4 className="text-start mb-3" style={{'fontSize':'2.1rem'}}>
                                        <strong>¿A qué nos referimos con...?</strong>
                                    </h4>
                                    <h5 style={{'fontSize':'1.5rem'}} className="text-start">Da click aquí para comprender el significado de los términos asociados a tu seguro</h5>
                                </div>
                                <div className="col-12 col-md-4">
                                    <NavLink to='/glosario'>
                                        <button className="btn__azul w-100">
                                            <span>glosario de términos</span>
                                        </button>
                                    </NavLink>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    </>)
}

export default Glosario